/**
 * @desc 查询spu
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.ProductMasterResponseDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/productMaster/byUniqueSpuList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
